import {Account} from "@/models/finance/account";
import {WebFormModel} from "capitalist-shared/src/core/model";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import {useRequest} from "vue-request";

export enum PayoutStates {
  UnselectedSystem = 1,
  ModelLoading,
  ModelLoadingFail,
  RequisitesEdit,
  RequisitesSubmitting,
  VerificationLoading,
  VerificationLoadingFail,
  Verification,
  VerificationSubmitting,
  Result
}

export enum FormBlockingLayerStates {
  Plain = 'plain',
  Loader = 'loader',
  Complete = 'complete'
}

export interface PayoutPageUserProfileInterface {
  username: string
  verified: boolean
  type: string
  advanced: {
    legal: boolean,
    individual: boolean,
    mass: boolean,
  }
}

export const fetchPayoutPageData = () => {
  return httpAxiosApi.post('/webapi/finance/payout/PayoutSettings').then((result: any) => {
    return {...result.data};
  })
}

export const usePayoutPageData = () => {
  return useRequest(fetchPayoutPageData, {
    cacheKey: 'payoutPageData',
    cacheTime: 1000 * 60 * 5,
    errorRetryInterval: 2000,
    errorRetryCount: 3
  })
}

export const fetchSourceAccounts = () => {
  return httpAxiosApi.post('/webapi/webapi/accounts').then(({data}) => {
    return (data.accounts ? [...data.accounts] : []).map((accountData: any) => {
      return Account.createFromData(accountData);
    })
  })
}

export const useSourceAccounts = () => {
  return useRequest(fetchSourceAccounts, {
    cacheKey: 'sourceAccounts',
    cacheTime: 1000 * 60 * 5,
    errorRetryInterval: 2000,
    errorRetryCount: 3,
    pollingInterval: 60 * 5000
  })
}

export class PayPage extends WebFormModel {
  groups = [];
  user: PayoutPageUserProfileInterface | null = null;
  system = null;
  recent = [];
  sourceCurrency = null;
  sourceAccountNumber = '';
  sourceAccountsCardsPro = false;
  templateModel = null;
  accounts = [];
  account = null;
  assetsUrl = '';
  payoutLogoUrl = '';

  pageDataLoadingStatus = new RemoteRequestState();


  async reloadAccounts() {
    return this.accounts = await fetchSourceAccounts();
  }

  setSourceAccountNumber(accountNumber: string | any, onEmptyOnly = false) {
    if (onEmptyOnly && this.sourceAccountNumber) {
      return;
    }
    if (!accountNumber || (typeof accountNumber !== 'string')) {
      this.sourceAccountNumber = '';
      this.account = null;
      return;
    }
    const account = this.accounts.find((account: any) => account.number === accountNumber);
    if (!account) {
      this.sourceAccountNumber = '';
      this.account = null;
      return;
    } else {
      try {
        if (this.sourceCurrency
          && Array.isArray(this.sourceCurrency)
          && (this.sourceCurrency.length > 0)
          && (!this.sourceCurrency.includes(account.currency))) {
          this.sourceAccountNumber = '';
          this.account = null;
          return;
        }
      } catch (e) {}

      if (!this.sourceAccountsCardsPro && account.isCardsPro) {
        this.sourceAccountNumber = '';
        this.account = null;
        return;
      }

      this.sourceAccountNumber = accountNumber;
      this.account = account;
    }
  }

  loadPageData() {
    if (this.pageDataLoadingStatus.isLoading) {
      return;
    }
    this.pageDataLoadingStatus.loadStart();
    return fetchPayoutPageData().then((result: any) => {
      this.groups = result.groups;
      this.accounts = result.accounts.map((accountData: any) => {
        return Account.createFromData(accountData);
      })
      this.assetsUrl = result.assetsUrl;
      this.payoutLogoUrl = result.payoutLogoUrl;
      this.user = result.profile;
      this.pageDataLoadingStatus.loadEnd();
      return result;
    }).catch((error: any) => {
      this.checkAxiosError(error);
      this.pageDataLoadingStatus.loadError();
      throw error;
    })
  }
}


import * as scrollIntoView from 'scroll-into-view';
import { CurrencyCode } from "@/models/core/currency";

export type ScrollToOptsType = {
  duration?: number,
  goNextTick?: boolean,
  nextTick?: () => void
}

export const scrollToFirstError = (opts: ScrollToOptsType = {}) => {
  scrollTo('.form-group-has-error', {
    duration: 500,
    goNextTick: true,
    nextTick: null,
    ...opts,
  });
}

export const scrollTo = async (id: string, opts: ScrollToOptsType = {
  duration: 1000, goNextTick: true, nextTick: null
}) => {

  if (typeof window == 'undefined' || !window?.document) return;

  const {goNextTick, nextTick, duration} = {duration: 1000, goNextTick: true, nextTick: null, ...opts};

  if (goNextTick && nextTick)
    await nextTick()

  scrollIntoView(window.document.querySelector(id), {
    time: duration,
    cancellable: true
    // align: {
    //   // top: 0,
    //   // topOffset: 0
    // }
  })

  // if (nextTick)
  // this.$nextTick(function () {
  //   if ($(id).length > 0)
  //     $(window).scrollTo($(id).eq(0), duration);
  // });
  // else if ($(id).length > 0) {
  // $(window).scrollTo($(id).eq(0), duration);
}
